import React, { useEffect, useRef } from 'react'
// import ReactGA from 'react-ga'
import { useParams } from 'react-router-dom'

import MainBanner from '../MainBanner/MainBanner'
// import BannerType1, { BannerType1Data } from './BannerType1/BannerType1'
import BannerType2, { BannerType2Data } from './BannerType2/BannerType2'
import CollectionPromoBanner from './CollectionPromoBanner'
// import MainPromoBanner from './MainPromoBanner'
import { BannerData, NewBannerProps } from './NewBanner.types'
import { observAnalaytics, options } from './NewBannerHelpers'
import PromoBanner from './PromoBanner'

export const data: BannerData = [
  {
    href: 'https://www.pik.ru/pages/dvorpark?utm_source=rbc&utm_medium=display&utm_content=blago',
    name: 'Дворы-парки',
    text: 'Цветы всех<br>цветов',
    color: '#E85490',
  },
  {
    href: 'https://www.pik.ru/pages/dvorpark?utm_source=rbc&utm_medium=display&utm_content=blago',
    name: 'Дворы-парки',
    text: 'Зелень<br>повсюду',
    color: '#71B001',
  },
  // {
  //   href: 'https://www.pik.ru/pages/dvorpark?utm_source=rbc&utm_medium=display&utm_content=blago',
  //   name: 'Дворы-парки',
  //   text: 'Спорт<br>для всех',
  //   color: '#AF5648',
  // },
]

export const dataMain: BannerData = [
  {
    href: 'https://www.pik.ru/search?projects=1&requiredTags=specialprice&utm_source=rbc&utm_medium=display&utm_content=specialprice',
    name: 'Специальные цены',
    text: '',
    color: '#FC4C02',
  },
]

// const bannerMain: BannerType1Data = {
//   href: 'https://www.pik.ru/search/ready?projects=1&utm_source=rbc',
//   leftText: 'Переезжайте<br>в готовые квартиры',
//   rightText: '<span>за</span><big>35 000</big><br>рублей в месяц',
//   textLink:
//     'Оценивайте свои финансовые возможности и&nbsp;риски.<br>Изучите все условия кредита (займа) на&nbsp;vtb.ru/personal/ipoteka/dlya-semej-s-detmi/',
//   bottomText:
//     'Реклама. Полная стоимость кредита 23,157%&nbsp;&mdash; 30,233%. Ставка в&nbsp;размере 5,99% годовых на&nbsp;весь срок кредита при условии комплексного страхования. Первый взнос от&nbsp;20,1%, срок&nbsp;&mdash; до&nbsp;30&nbsp;лет, сумма кредита до&nbsp;12&nbsp;млн руб. Ставка&nbsp;5,99% обеспечивается за&nbsp;счет субсидирования из&nbsp;средств ООО ПИК-Инвестпроект. Заемщику необходимо соответствовать требованиям госпрограммы и&nbsp;банка. Банк вправе отказать в&nbsp;выдаче кредита без объяснения причин. Кредит предоставляет Банк ВТБ (ПАО). Генеральная лицензия Банка России &#8470;&nbsp;1000. Рекламодатель ПАО&nbsp;&laquo;ПИК СЗ&raquo;, ОГРН 1027739137084, адрес: 123242, Москва, ул.&nbsp;Баррикадная, д.&nbsp;19/1. Проектная декларация на&nbsp;наш.дом.рф.',
// }

const bannerMain2: BannerType2Data = {
  href: 'https://www.pik.ru/search/ready?projects=1&utm_source=rbc',
  leftText: 'Переезжайте в&nbsp;готовые квартиры от&nbsp;6,2 млн руб.',
  textLink: '',
  bottomText:
    'Количество предложения ограничено. ПАО &quot;ПИК СЗ&quot;. ОГРН 1027739137084. Юр.&nbspадрес: 123242, г.&nbspМосква, ул.&nbspБаррикадная, д.19, стр.&nbsp;1. Подробнее на&nbsp;pik.ru. Проектные декларации проектов на&nbsp;наш.дом.рф',
}

// const bannerMain = {
//   href: 'https://www.pik.ru/search/ready?projects=1&utm_source=rbc',
//   name: 'На&nbsp;старте продаж<br><span>Успейте забронировать по&nbsp;выгодным ценам</span>',
//   text: '',
//   color: '#FC4C02',
//   lead: 'Количество предложения ограничено. Срок действия акции до&nbsp;20.12.2024. ПАО ПИК СЗ. ОГРН 1027739137084. Юр.&nbsp;адрес: 123242, г.&nbsp;Москва, ул.&nbsp;Баррикадная, д.19, стр.&nbsp;1. Подробнее на&nbsp;pik.ru. Проектные декларации проектов на&nbsp;наш.дом.рф.',
// }

// const bannerMain = {
//   href: 'https://www.pik.ru/il-luga?utm_source=rbc',
//   name: 'Ильинские луга<br>Забронируйте на старте продаж',
//   text: '',
//   color: '#FC4C02',
//   lead: 'Застройщик ООО &laquo;СЗ&nbsp;&laquo;ГРАДОЛИМП&raquo;, адрес: 141021, МО, г. Мытищи, ул. Борисовка, дом&nbsp;4, пом. Х, комната 21, ОГРН: 1137746339720. Подробности на&nbsp;pik.ru. Проектная декларация на&nbsp;сайте наш.дом.рф.',
// }

const banner74 = {
  href: 'https://www.pik.ru/search?projects=1&currentBenefit=semejnaya-ipoteka-5-9&utm_source=rbc',
  name: 'Семейная ипотека<br>от&nbsp;22&nbsp;000&nbsp;руб/мес',
  text: '',
  color: '#FC4C02',
  leadLink:
    'Оценивайте свои финансовые возможности и&nbsp;риски. Изучите все условия кредита (займа) на&nbsp;vtb.ru/personal/ipoteka/dlya-semej-s-detmi/',
  lead: 'Реклама. Полная стоимость кредита 23,157%&nbsp;&mdash; 30,233%. Ставка в&nbsp;размере 5,99% годовых на&nbsp;весь срок кредита при условии комплексного страхования. Первый взнос от&nbsp;20,1% , срок&nbsp;&mdash; до&nbsp;30&nbsp;лет, сумма кредита до&nbsp;12&nbsp;млн руб. Ставка&nbsp;5,99% обеспечивается за&nbsp;счет субсидирования из&nbsp;средств ООО ПИК-Инвестпроект. Заёмщику необходимо соответствовать требованиям госпрограммы и&nbsp;банка. Банк вправе отказать в&nbsp;выдаче кредита без объяснения причин. Кредит предоставляет Банк ВТБ (ПАО). Генеральная лицензия Банка России &#8470;&nbsp;1000. Рекламодатель ПАО &laquo;ПИК СЗ&raquo; ОГРН 1027739137084, адрес: 123242, Москва, ул.&nbsp;Баррикадная, д.&nbsp;19/1. Проектная декларация на&nbsp;наш.дом.рф.',
}

export const banner77 = {
  href: 'https://www.pik.ru/search?projects=1&requiredTags=gotovoe&utm_source=rbc',
  name: 'Готовые<br>квартиры',
  text: 'от <span class="price">19 600</span><br><span class="text">рублей в месяц</span>',
  color: '#FC4C02',
  lead: 'Кредит предоставляет АКБ &laquo;Абсолют Банк&raquo; (ПАО). Полная стоимость кредита (ПСК) от&nbsp;6,884% до&nbsp;11,831%. Ставка&nbsp;5,99% указанный размер процентной ставки устанавливается для клиентов соответствующих Правилам программы и&nbsp;заключивших кредитный договор в&nbsp;период с&nbsp;25.07.2024 по&nbsp;31.12.2030. Ставка&nbsp;5,24%, указанный размер процентной ставки устанавливается для клиентов 25.07.2024 по&nbsp;31.12.2030, с&nbsp;ребенком-инвалидом, возраст которого не&nbsp;достиг 7&nbsp;лет на&nbsp;дату заключения&nbsp;КД, или&nbsp;же есть ребенок-инвалид. Ставка&nbsp;4%, указанный размер процентной ставки устанавливается для клиентов соответствующих Правилам программы и&nbsp;заключивших кредитный договор в&nbsp;период с&nbsp;31.08.2024 по&nbsp;31.12.2030. на&nbsp;покупку объекта недвижимости у&nbsp;ПАО &laquo;ПИК СЗ&raquo;, ОГРН&nbsp;1027739137084, ИНН&nbsp;7713011336. Первоначальный взнос не&nbsp;менее 20,01% от&nbsp;стоимости жилого помещении, при условии подключения Абсолютной ставки 0,5% и&nbsp;0,25% КСС. Подробная информация об&nbsp;Условиях программы: https://absolutbank.ru/personal/loans/mortgage/gosprogramma/ Условия действительны c&nbsp;25.07.2024. АКБ &laquo;Абсолют Банк&raquo; (ПАО). Генеральная лицензия Банка России &#8470;&nbsp;2306. Реклама. *не&nbsp;является офертой. Застройщик ПАО &laquo;ПИК СЗ&raquo; ОГРН 1027739137084, адрес: 123242, Москва, ул. Баррикадная, д. 19/1. Проектная декларация на&nbsp;наш.дом.рф.',
}

export const NewBanner = (props: NewBannerProps) => {
  const { pageType, bannerNumber } = props
  const { id } = useParams()

  // const [currentBanner, setCurrentBanner] = useState<number>(0)
  const bannerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // incrementNumber()
    // const currentIndex = localStorage.getItem('bannerIndex')
    // let currentBanner = 0

    // if (currentIndex) {
    //   setCurrentBanner(() => {
    //     currentBanner = parseInt(currentIndex)
    //     return parseInt(currentIndex)
    //   })
    // }

    // for analytics
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target)

          observAnalaytics(
            `${
              pageType === 'main'
                ? `${bannerMain2.leftText}`
                : `${banner77.name} ${banner77.text}`
            }`,
            id,
            pageType,
            props.place
          )
        }
      })
    }, options)

    if (bannerRef.current) {
      observer.observe(bannerRef.current)
    }

    return () => {
      if (bannerRef.current) {
        observer.unobserve(bannerRef.current)
      }
    }
  }, [])

  if (bannerNumber === 77) {
    return (
      <section className='section' ref={bannerRef}>
        <CollectionPromoBanner
          place={props.place}
          id={id}
          pageType={pageType}
          bannerData={banner77}
          customClass='banner--77'
        />
      </section>
    )
  } else if (bannerNumber === 74) {
    return (
      <section className='section' ref={bannerRef}>
        <PromoBanner
          place={props.place}
          id={id}
          pageType={pageType}
          bannerData={banner74}
          textLeadLink={banner74.leadLink}
          textLead={banner74.lead}
          customClass={['banner--74', 'bunner-with-button']}
        />
      </section>
    )
  } else if (pageType === 'main') {
    return (
      <section className='section' ref={bannerRef}>
        <BannerType2
          place={props.place}
          id={id}
          pageType={pageType}
          bannerData={bannerMain2}
        />
      </section>
    )
  } else {
    return (
      <section className='section' ref={bannerRef}>
        <MainBanner place={props.place} id={id} pageType={pageType} />
      </section>
    )
  }
}
